package com.milta.core.localization.translations.fr

import com.milta.core.localization.AppStrings

val FrStrings = AppStrings(
    common = Common,
    auth = Auth,
    errors = Errors,
    home = Home,
    profile = Profile,
    subscription = Subscription,
    route = Route,
    team = Team,
    subscriptionExpired = SubscriptionExpired,
    imports = Imports,
    ocrScan = OcrScan,
    packageLabelScan = PackageLabelScan,
    spreadsheetImport = SpreadsheetImport,
    webImportRoute = WebImportRoute,
    settings = Settings,
    webDashboard = WebDashboard,
    webHistorique = WebHistorique,
)
